import React from 'react';

/**
 * Use cancel double space dot mac behaviour
 */
const useCancelDoubleSpaceDotMacBehaviour = ({
  onKeyPress,
  onKeyUp,
  onKeyDown,
  onChange
}: {
  onKeyPress?: (event: any) => void;
  onKeyUp?: (event: any) => void;
  onKeyDown?: (event: any) => void;
  onChange: (event: any) => void;
}) => {
  let action: string;

  const _onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    action = event.type;

    onKeyPress?.(event);
  };

  const _onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    action = event.type;

    onKeyDown?.(event);
  };

  const _onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      action != 'keypress' &&
      event.keyCode == 32 &&
      (event.target as any).value.endsWith('. ')
    ) {
      console.warn(
        "keypress action has been skipped, space-bar has been pressed and the input ends with '. '"
      );

      (event.target as any).value = (event.target as any).value.replace(
        new RegExp('. ' + '$'),
        ' '
      );

      onChange(event);
    }

    onKeyUp?.(event);
  };

  return {
    _onKeyPress,
    _onKeyUp,
    _onKeyDown
  };
};

export { useCancelDoubleSpaceDotMacBehaviour };
